import { gql } from "graphql-tag";

import { documentLink, collectionLink } from "~/app/prismic/prismic-fragments";

export const getShopByOfferV2 = (pageType, slicePrefix = "Body") => gql`
  fragment ${pageType}_shop_by_offer_v2 on ${pageType}${slicePrefix}Shop_by_offer_v2 {
    type
    label
    variation {
      variation: __typename
      ... on ${pageType}${slicePrefix}Shop_by_offer_v2Default {
        primary {
          heading
          list_type
        }
        items {
          image
          sub_title
          link {
            ...documentLink
            ...collectionLink
          }
        }
      }
    }
  }
  ${documentLink}
  ${collectionLink}
`;
